import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Typography, GRAY, Box } from '@applyboard/ui-components';
import { getQuestion } from "../Utilities/LanguageHelper";
var Question = function Question(_ref) {
  var keyName = _ref.keyName;
  return /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: GRAY[5]
    },
    variant: "h4"
  }, getQuestion(keyName)));
};
export default Question;